var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOptions(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 4,
    height: 19,
    viewBox: "0 0 4 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 3.8C3.10457 3.8 4 2.94934 4 1.9C4 0.850659 3.10457 0 2 0C0.89543 0 0 0.850659 0 1.9C0 2.94934 0.89543 3.8 2 3.8Z",
    fill: "#292931"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 11.4C3.10457 11.4 4 10.5493 4 9.5C4 8.45066 3.10457 7.6 2 7.6C0.89543 7.6 0 8.45066 0 9.5C0 10.5493 0.89543 11.4 2 11.4Z",
    fill: "#292931"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2 19C3.10457 19 4 18.1493 4 17.1C4 16.0507 3.10457 15.2 2 15.2C0.89543 15.2 0 16.0507 0 17.1C0 18.1493 0.89543 19 2 19Z",
    fill: "#292931"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOptions);
export default __webpack_public_path__ + "static/media/options.4e0edd5751801d8b0ad0ffd39f683a43.svg";
export { ForwardRef as ReactComponent };